<template>
  <q-card flat bordered style="width:100%">
    <q-card-section class="q-pa-sm text-brand7 q-pb-md bg-grey-2">
      <div class="q-px-sm">
        <span class="semi-bordered-bottom text-bold">Card Information</span>
      </div>
    </q-card-section>

    <q-separator />
    <q-card-section>
      <label>Card Number *</label>
      <app-editable-input
        :data="value.cardNumber"
        name="cardNumber"
        mask="#### #### #### ####"
        @input="
          handleChangeInput($event);
          if (validation.cardNumber.$dirty)
            delayTouch(validation.cardNumber, $options.touchMap);
        "
        :error="validation.cardNumber.$error"
        outlined
        dense
        color="brand6"
      />
      <label>Expire Month *</label>
      <app-select-input
        :value="value.exprMonth"
        :options="exprMonthOptions"
        @input="
          handleChangeSelect('exprMonth', $event);
          delayTouch(validation.exprMonth, $options.touchMap);
        "
        :error="validation.exprMonth.$error"
        outlined
        dense
        color="brand6"
      />
      <label>Expire Year *</label>
      <app-select-input
        :value="value.exprYear"
        :options="exprYearOptions"
        @input="
          handleChangeSelect('exprYear', $event);
          delayTouch(validation.exprYear, $options.touchMap);
        "
        :error="validation.exprYear.$error"
        outlined
        dense
        color="brand6"
      />
      <label>CVV *</label>
      <app-editable-input
        :data="value.cvv"
        name="cvv"
        @input="
          handleChangeInput($event);
          delayTouch(validation.cvv, $options.touchMap);
        "
        :error="validation.cvv.$error"
        outlined
        dense
        color="brand6"
      />
    </q-card-section>
  </q-card>
</template>

<script>
import AppEditableInput from '@client/components/form/editable-input';
import AppSelectInput from '@client/components/form/select-input';

export default {
  name: 'AppCreditCardDetails',
  props: {
    value: Object,
    validation: Object
  },
  components: {
    AppEditableInput,
    AppSelectInput
  },
  data() {
    return {
      exprMonthOptions: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12'
      ],
      exprYearOptions: [
        '2024',
        '2025',
        '2026',
        '2027',
        '2028',
        '2029',
        '2030',
        '2031',
        '2032',
        '2033',
        '2034',
        '2035'
      ]
    };
  },
  methods: {
    handleChangeInput(value) {
      const { name, model } = value;
      if (name === 'cardNumber') {
        this.$emit('input', {
          ...this.value,
          [name]: model.split(' ').join('')
        });
      } else {
        this.$emit('input', {
          ...this.value,
          [name]: model
        });
      }
    },
    handleChangeSelect(name, model) {
      this.$emit('input', {
        ...this.value,
        [name]: model
      });
    }
  }
};
</script>
<style lang="scss"></style>
